<!-- Copyright (c) 2021 VMware, Inc. All rights reserved. VMware Confidential -->
<div class="content-area" *ngIf="show403Error">
    Error 403 - No service access
    <!--csp-no-service-access-page
       [serviceReflink]="serviceReflink"
       [orgId]="orgId$ | async"
       [mode]="mode"
       (switchOrg)="orgChange($event)">
    </csp-no-service-access-page-->
</div>
